export const numberFormatter = (number) => {
    if (typeof(number) === Number) {
        return +number.toFixed(2);
    } else {
        return +number
    }
    
}